import deleteData from "../services/deleteData";
import fetchData from "../services/fetchData";
import patchData from "../services/patchData";
import postData from "../services/postData";

const handleFetchEntries = async ({ page, limit, status, params }: any) => {
  const uri = `v1/entries?page=${page}&limit=${limit}&status=${status}&${params}`;
  const response = fetchData({ uri });
  return response;
};

const handleFetchAllEntries = async ({ page, limit, params }: any) => {
  const uri = `v1/entries/all/paginated?page=${page}&limit=${limit}&${params}`;
  const response = fetchData({ uri });
  return response;
};

const handleFetchEntry = async ({ _id }: any) => {
  const uri = `v1/entries/${_id}`;
  const response = fetchData({ uri });
  return response;
};

const handleExportEntries = async () => {
  const uri = `v1/entries/export/all`;
  const response = fetchData({ uri });
  return response;
};

const handleFetchEntriesCount = async ({ status }: any) => {
  const uri = `v1/entries/count/all?status=${status}`;
  const response = fetchData({ uri });
  return response;
};

const handleCreateEntry = async (data: any) => {
  const uri = `v1/entries`;
  const response = postData({ data, uri });
  return response;
};

const handleUpdateEntry = async ({ _id, data }: any) => {
  const uri = `v1/entries/${_id}`;
  const response = patchData({ data, uri });
  return response;
};

const handleDeleteEntry = async ({ _id, data }: any) => {
  const uri = `v1/entries/${_id}`;
  const response = deleteData({ data, uri });
  return response;
};

const handleEntriesTopRegions = async ({ params }: any) => {
  const uri = `v1/entries/top/regions?${params}`;
  const response = fetchData({ uri });
  return response;
};

const handleEntriesTopWards = async ({ params }: any) => {
  const uri = `v1/entries/top/wards?${params}`;
  const response = fetchData({ uri });
  return response;
};

const handleEntriesTopDistricts = async ({ params }: any) => {
  const uri = `v1/entries/top/districts?${params}`;
  const response = fetchData({ uri });
  return response;
};

const handleEntriesTopModels = async () => {
  const uri = `v1/entries/top/models`;
  const response = fetchData({ uri });
  return response;
};

const handleEntriesTopVehicles = async ({ params }: any) => {
  const uri = `v1/entries/top/vehicles?${params}`;
  const response = fetchData({ uri });
  return response;
};

const handleEntriesTopMakes = async ({ params }: any) => {
  const uri = `v1/entries/top/makes?${params}`;
  const response = fetchData({ uri });
  return response;
};

const handleEntriesTopBranches = async ({ params }: any) => {
  const uri = `v1/entries/top/branches?${params}`;
  const response = fetchData({ uri });
  return response;
};

const handleEntriesByGenders = async ({ params }: any) => {
  const uri = `v1/entries/top/genders?${params}`;
  const response = fetchData({ uri });
  return response;
};

export {
  handleFetchEntries,
  handleFetchEntry,
  handleExportEntries,
  handleCreateEntry,
  handleUpdateEntry,
  handleDeleteEntry,
  handleFetchAllEntries,
  handleFetchEntriesCount,
  handleEntriesTopRegions,
  handleEntriesTopWards,
  handleEntriesTopDistricts,
  handleEntriesTopModels,
  handleEntriesTopVehicles,
  handleEntriesTopMakes,
  handleEntriesTopBranches,
  handleEntriesByGenders,
};
